import { defineStore } from 'pinia';
import { Ref, ref } from 'vue';
import { pcInterface, pcFilterInterface, responseDataPageableInterface } from '@/types/types.d';
import { PcModel } from '@/models/PcModel';
import ApiService from '@/utils/ApiService';
import { exportAsCsvFile } from '@/utils/commonUtils';
import { DEFAULT_PCS_EXPORT_FILENAME } from '@/static/constants';
import { PcFilterModel } from '@/models/PcFilterModel';
import { usePagesUtilStore } from "@/stores/pagesUtilStore";
import messages from '@/utils/messages';

export const usePCStore = defineStore('pc', () => {
  const pcs: Ref<pcInterface[]> = ref([] as pcInterface[]);
  const selectedPCs: Ref<pcInterface[]> = ref([] as pcInterface[]);
  const pcFilter: Ref<pcFilterInterface> = ref(new PcFilterModel());
  const totalElements = ref(0)

  const pagesUtilStore = usePagesUtilStore();

  const verificarIdsNaApi = async (ids: string[]) => {
    try {
      const idsSemEspaco = ids.map(id => id.trim());

      const response = await ApiService.post<pcInterface[]>(
        process.env.VUE_APP_API_CAMPAIGN_ENDPOINT,
        process.env.VUE_APP_API_CAMPAIGN_ROUTE_POST_PCS_EXISTING,
        idsSemEspaco
      );

      const existentes = response.map(pc => String(pc.codpontocaptura));
      const naoEncontrados = idsSemEspaco.filter(id => !existentes.includes(id));

      if (naoEncontrados.length > 0) {
        messages.showWarningMsg("Os seguintes PCs não existem: " + naoEncontrados.join(', '));
      }

      if (existentes.length == 0) {
        pagesUtilStore.showModalPCs = false;
      }

      if (pagesUtilStore.importPlanilha) {
        selectedPCs.value = response.map(data => new PcModel(data));
        pagesUtilStore.importPlanilha = false;
      }

    } catch (error) {
      console.error(error);
    }
  };

  const fetchPCs = async (page: number, size: number | null, ids: string[] | null = null) => {
    const defaultSize = 10;

    try {
      const codpontocaptura = ids ?? (
        pcFilter.value.filterPc.codpontocaptura
          ? Array.isArray(pcFilter.value.filterPc.codpontocaptura)
            ? pcFilter.value.filterPc.codpontocaptura
            : [pcFilter.value.filterPc.codpontocaptura]
          : []
      );

      if (page == 0 && codpontocaptura.length > 0 && !pagesUtilStore.idsVerified) {
        await verificarIdsNaApi(codpontocaptura);
        pagesUtilStore.idsVerified = true;
      }

      const params = {
        codpontocaptura: codpontocaptura.length ? codpontocaptura.map(Number) : undefined,
        nompontocaptura: pcFilter.value.filterPc.nompontocaptura || undefined,
        nomcidredeautoatndto: pcFilter.value.filterPc.nomcidredeautoatndto || undefined,
        ufredeautoatndto: pcFilter.value.filterPc.ufredeautoatndto || undefined,
        nomsegmmerclocalptoatndto: pcFilter.value.filterPc.nomsegmmerclocalptoatndto || undefined,
        nomtpmaqautoatndto: pcFilter.value.filterPc.nomtpmaqautoatndto || undefined,
        codsubredeautoatndto: (() => {
          const val = pcFilter.value.filterPc.codsubredeautoatndto;
          if (!val || (Array.isArray(val) && val.length === 0)) return null;
          return Array.isArray(val) ? val : [val];
        })(),
        page,
        size: size ?? defaultSize
      };

      console.log("PARAMS ENVIO >>>", JSON.stringify(params, null, 2));

      const responseData: responseDataPageableInterface<pcInterface> = await ApiService.post(
        process.env.VUE_APP_API_CAMPAIGN_ENDPOINT,
        process.env.VUE_APP_API_CAMPAIGN_ROUTE_POST_PCS,
        params
      );

      console.log("RESPOSTA API >>>", responseData);

      pcs.value = [];
      totalElements.value = 0;

      if (responseData) {
        pcs.value = responseData.content
          ? responseData.content.map(data => new PcModel(data))
          : [];

        totalElements.value = responseData.totalElements ?? 0;
      }


      return responseData;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };


    











  /*const fetchAllExistingIds = async (): Promise<string[]> => {
    try {
      let allIds: string[] = [];
      let page = 0;
      let hasMoreData = true;

      while (hasMoreData) {
        const params = {
          size: 8000, 
          page: page,
        };

        const responseData: responseDataPageableInterface<pcInterface> = await ApiService.post(
          process.env.VUE_APP_API_CAMPAIGN_ENDPOINT,
          process.env.VUE_APP_API_CAMPAIGN_ROUTE_POST_PCS,
          params
        );

        const ids = responseData?.content.map(data => String(data.codpontocaptura));
        allIds = allIds.concat(ids);

        hasMoreData = responseData?.content.length > 0;
        page += 1;
      }

      return allIds;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  let existingIds: string[] = [];

  const verifyNonExistingIds = async (codpontocaptura: string[]) => {
    if (codpontocaptura.length === 0) {
      return;
    }
    
    if (!pagesUtilStore.idsVerified) {
      existingIds = await fetchAllExistingIds();
      const nonExistingIds = codpontocaptura.filter(id => !existingIds.includes(id));

      if (nonExistingIds.length > 0) {
        messages.showWarningMsg("Os seguintes PCs não existem: " + nonExistingIds.join(', '));
      }

      pagesUtilStore.idsVerified = true; // Marcar como verificado
    }

  };

  const fetchPCs = async (page: number, size: number | null, ids: string[] | null = null) => {
    const defaultSize = 10;

    try {

      const codpontocaptura = ids ? ids : (pcFilter.value.filterPc.codpontocaptura ? String(pcFilter.value.filterPc.codpontocaptura).split(',') : []);

    
      await verifyNonExistingIds(codpontocaptura);


      const params = {
        codpontocaptura: codpontocaptura.length > 0 ? codpontocaptura : undefined,
        //codpontocaptura: ids ? ids : (pcFilter.value.filterPc.codpontocaptura ? String(pcFilter.value.filterPc.codpontocaptura).split(',') : undefined), 
        nompontocaptura: (pcFilter.value.filterPc.nompontocaptura ? pcFilter.value.filterPc.nompontocaptura : undefined),
        nomcidredeautoatndto: (pcFilter.value.filterPc.nomcidredeautoatndto ? pcFilter.value.filterPc.nomcidredeautoatndto : undefined),
        ufredeautoatndto: (pcFilter.value.filterPc.ufredeautoatndto ? pcFilter.value.filterPc.ufredeautoatndto : undefined),
        nomsubredeautoatndto: (pcFilter.value.filterPc.nomsubredeautoatndto ? pcFilter.value.filterPc.nomsubredeautoatndto : undefined),
        nomsegmmerclocalptoatndto: (pcFilter.value.filterPc.nomsegmmerclocalptoatndto ? pcFilter.value.filterPc.nomsegmmerclocalptoatndto : undefined),
        nomtpmaqautoatndto: (pcFilter.value.filterPc.nomtpmaqautoatndto ? pcFilter.value.filterPc.nomtpmaqautoatndto : undefined),
        page: page,
        size: (size ? size : defaultSize),
      }

      const responseData: responseDataPageableInterface<pcInterface> = await ApiService.post(
        process.env.VUE_APP_API_CAMPAIGN_ENDPOINT,
        process.env.VUE_APP_API_CAMPAIGN_ROUTE_POST_PCS,
        params
      );

      pcs.value.length = 0;

      if (responseData?.content) {
        pcs.value.push(...responseData.content.map(data => new PcModel(data)));
      }

      return responseData;

    } catch (error) {
      console.error(error);

      throw error;
    };
  }; */

  const resetState = () => {
    pcs.value.length = 0;
    selectedPCs.value.length = 0;
  };

  const resetFilterState = () => {
    pcFilter.value.filterPc.codpontocaptura = undefined
    pcFilter.value.filterPc.nompontocaptura = ""
    pcFilter.value.filterPc.nomcidredeautoatndto = ""
    pcFilter.value.filterPc.ufredeautoatndto = ""
    pcFilter.value.filterPc.nomsubredeautoatndto = []
    pcFilter.value.filterPc.codsubredeautoatndto = []
    pcFilter.value.filterPc.nomsegmmerclocalptoatndto = ""
    pcFilter.value.filterPc.nomtpmaqautoatndto = ""
  }

  const exportPcsAsCsv = (paramPcsToExport: Array<pcInterface>, paramFilename: string = DEFAULT_PCS_EXPORT_FILENAME) => {
    if (paramPcsToExport) {
      const pcsToExport = paramPcsToExport.map(p => ({
        "Código": p.codpontocaptura,
        "Nome PC": p.nompontocaptura,
        "Cidade": p.nomcidredeautoatndto,
        "UF": p.ufredeautoatndto,
        "Subrede": p.nomsubredeautoatndto,
        "Segmento": p.nomsegmmerclocalptoatndto,
        "Tipo de Máquina": p.nomtpmaqautoatndto
      }));

      exportAsCsvFile(pcsToExport, paramFilename);
    }
  }

  const setSelectedPCs = (pcs: pcInterface[]) => {
    selectedPCs.value = pcs.map(pc => new PcModel(pc))
  }

  return {
    pcs,
    selectedPCs,
    pcFilter,
    totalElements,
    fetchPCs,
    resetState,
    resetFilterState,
    exportPcsAsCsv,
    verificarIdsNaApi,
    setSelectedPCs
  }
})
